import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage, useIntl } from 'react-intl';
import cx from 'classnames';
import Tabs from 'react-bootstrap/lib/Tabs';
import Tab from 'react-bootstrap/lib/Tab';

import PanelItem from '../PanelItem';
import NoItem from '../NoItem';

import messages from '../../../locale/messages';

import withStyles from 'isomorphic-style-loader/withStyles';
import s from './PanelWrapper.css';

const PanelWrapper = ({ data: { ManageListings, refetch, loading } }) => {
  const [searchValue, setSearchValue] = useState('');
  const { formatMessage } = useIntl();

  const listedItems = [];
  const inProgressItems = [];
  const unListedItems = [];

  if (ManageListings?.status === 200 && ManageListings?.userListingCount > 0) {
    ManageListings?.results?.forEach((item) => {
      if (!item?.isReady) {
        inProgressItems.push(item);
      } else if (item?.isReady && item?.isPublished) {
        listedItems.push(item);
      } else if (item?.isReady && !item?.isPublished) {
        unListedItems.push(item);
      }
    });

    return (
      <div className={cx(s.panelBorder, 'tabReservation')}>
        <Tabs defaultActiveKey={2} id="uncontrolled-tab-example" className='commonListingTab'>
          <Tab eventKey={2} title={<FormattedMessage {...messages.listed} />}>
            <PanelItem
              data={listedItems}
              refetch={refetch}
              loading={loading}
              searchKey={searchValue}
              setValue={setSearchValue}
            />
          </Tab>
          <Tab eventKey={1} title={<FormattedMessage {...messages.panelHeader1} />}>
            <PanelItem
              data={inProgressItems}
              refetch={refetch}
              loading={loading}
              searchKey={searchValue}
              setValue={setSearchValue}
            />
          </Tab>
          <Tab eventKey={3} title={<FormattedMessage {...messages.unListed} />}>
            <PanelItem
              data={unListedItems}
              refetch={refetch}
              loading={loading}
              searchKey={searchValue}
              setValue={setSearchValue}
            />
          </Tab>
        </Tabs>
      </div>
    );
  } else {
    return <NoItem />;
  }
};

PanelWrapper.propTypes = {
  data: PropTypes.shape({
    ManageListings: PropTypes.shape({
      status: PropTypes.number,
      userListingCount: PropTypes.number,
      results: PropTypes.arrayOf(PropTypes.object)
    }),
    refetch: PropTypes.func,
    loading: PropTypes.bool
  }).isRequired
};

export default withStyles(s)(PanelWrapper);